import { object, string } from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import ScrollRenderer from 'yoda-site-components/lib/components/Renderers/ScrollRenderer';
import {
    selectDeviceName,
    selectPreferences,
} from 'yoda-site-components/lib/selectors/ContextSelector';
import { defaultPreferences } from './Constant';

const BelowTheFold = ({ children, offset, height }) => {
    const deviceName = useSelector(selectDeviceName);
    const preferences = useSelector(selectPreferences);
    const configOffset = get(preferences, 'renderingStrategy.pdp.offset', offset);
    const configHeight = get(preferences, 'renderingStrategy.pdp.height', height);
    return React.Children.map(children, (child) =>
        child ? (
            <ScrollRenderer offset={configOffset[deviceName]} height={configHeight[deviceName]}>
                {React.cloneElement(child)}
            </ScrollRenderer>
        ) : null
    );
};

BelowTheFold.defaultProps = {
    offset: defaultPreferences.renderingStrategy.pdp.offset,
    height: defaultPreferences.renderingStrategy.pdp.height,
    children: null,
    deviceName: 'mobile',
};

BelowTheFold.propTypes = {
    offset: object,
    height: object,
    children: object,
    deviceName: string,
};

export default BelowTheFold;
